import {
  ADD_MILESTONE_SUCCESS,
  CREATE_SLA_TEMPLATE_LOADER,
  TEMPLATE_UPDATED_FOR_CLIENT,
  UPDATE_CLIENT_USERS,
  UPDATE_MILESTONE_BEGINS,
  UPDATE_MILESTONE_SUCCESS,
} from "../constants/SLA";

const slaState = {
  loader: false,
  milestones: [],
  paymentSchedule: [],
  owners: [
    { id: "1", value: "PSP" },
    { id: "2", value: "Client" },
  ],
  selectedMilestones: [],
  fetchSelectMilestoneLoader: false,
  selectedCalendarDates: [],
  createTemplateLoader: false,
  templateUpdated: false,
  templateUsers: [],
};

export const slaReducer = (state = slaState, action) => {
  switch (action.type) {
    case ADD_MILESTONE_SUCCESS:
      return {
        ...state,
        selectedMilestones: [...state.selectedMilestones, ...[action.data]],
      };
    case UPDATE_MILESTONE_BEGINS:
      return { ...state, fetchSelectMilestoneLoader: action.data };
    case UPDATE_MILESTONE_SUCCESS:
      return { ...state, selectedMilestones: action.data };
    case CREATE_SLA_TEMPLATE_LOADER:
      return { ...state, createTemplateLoader: action.data };
    case TEMPLATE_UPDATED_FOR_CLIENT:
      return { ...state, templateUpdated: action.data };
    case UPDATE_CLIENT_USERS:
    return { ...state, templateUsers: action.data };
    default:
      return { ...state };
  }
};
